export default __webpack_public_path__ + "static/dont-use-return-urls-5043bc3d04e1067a41c6eacfb90ee2be.png";